<script lang="ts" setup>
import type { BreadcrumbPageProps } from '.';

import { cn } from '@/utils';

const props = defineProps<BreadcrumbPageProps>();
</script>

<template>
	<span
		role="link"
		aria-disabled="true"
		aria-current="page"
		:class="
			cn('text-base font-medium leading-[162.5%] text-primary', props.class)
		"
	>
		<slot />
	</span>
</template>
